import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=6f152c70&"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js&"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLayout.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports